/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Currency
 * @export
 * @interface Currency
 */
export interface Currency {
    /**
     * Code of the currency in iso format
     * @type {string}
     * @memberof Currency
     */
    isocode?: string;
    /**
     * Name of the currency
     * @type {string}
     * @memberof Currency
     */
    name?: string;
    /**
     * Boolean flag whether currency is active
     * @type {boolean}
     * @memberof Currency
     */
    active?: boolean;
    /**
     * Symbol of the currency
     * @type {string}
     * @memberof Currency
     */
    symbol?: string;
}

/**
 * Check if a given object implements the Currency interface.
 */
export function instanceOfCurrency(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CurrencyFromJSON(json: any): Currency {
    return CurrencyFromJSONTyped(json, false);
}

export function CurrencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Currency {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isocode': !exists(json, 'isocode') ? undefined : json['isocode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
    };
}

export function CurrencyToJSON(value?: Currency | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isocode': value.isocode,
        'name': value.name,
        'active': value.active,
        'symbol': value.symbol,
    };
}

